import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { RadioGroup } from "../../../components/RadioInput";
import { AppContext } from "../../../context";
import styles from "./TripTypeField.scss";

const TripTypeField = ({
	className,
	selectedType,
	error,
	resetError,
	onChange
}) => {
	const [useAppState] = AppContext.useAppContext();

	return (
		<RadioGroup
			className={cx(className, styles.wrapper)}
			radioWrapperClassName={styles.radioWrapper}
			labelClassName={styles.radioLabel}
			label={useAppState.getDictionary("type")}
			hideLabel={true}
			name="flight-trip-type"
			options={[
				{
					label: useAppState.getDictionary("round-trip"),
					id: "RE",
					value: "RE"
				},
				{
					label: useAppState.getDictionary("one-way"),
					id: "OW",
					value: "OW"
				}
			]}
			selectedOption={selectedType}
			error={error}
			onChange={value => {
				resetError();
				onChange(value);
			}}
		/>
	);
};

TripTypeField.propTypes = {
	className: PropTypes.string,
	selectedType: PropTypes.oneOf(["RE", "OW"]),
	error: PropTypes.bool,
	resetError: PropTypes.func,
	onChange: PropTypes.func.isRequired
};

TripTypeField.defaultProps = {
	className: undefined,
	selectedType: "RE",
	error: false,
	resetError: () => {}
};

export default TripTypeField;
export { TripTypeField };
